import {
  axiosInstance,
  instance,
  logInstance,
  starInstance,
  mstance,
  starPlanInstance,
  actInstance,
  loginInstance,
} from './instance';
//设置埋点公参
const userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
const { uin } = userInfo;
const obj_data = {
  product: 71005,
  id: 71005,
  country: '',
  uin: uin,
  lang: '',
  ip: '__IP__',
  session_id: '',
  env: 0,
  version: '',
};
export const $get = (url, params = {}, config = {}) => {
  return axiosInstance.get(url, { params, ...config });
};

export const $post = (url, data = {}, config) => {
  return axiosInstance.post(url, data, config);
};
export const $Get = (url, params = {}, config = {}) => {
  return instance.get(url, { params, ...config });
};
export const $loginGet = (url, params = {}, config = {}) => {
  return loginInstance.get(url, { params, ...config });
};
export const $loginPost = (url, data = {}, config) => {
  return loginInstance.post(url, data, config);
};
//java post请求
export const $Post = (url, data = {}, config) => {
  return instance.post(url, data, config);
};
//埋点post请求
// export const $logPost = (url, data = {}, config) => {
//   return logInstance.post(url, data, config);
// };
//埋点post请求
export const $logPost = (url, data = {}, config) => {
  return logInstance.post(
    url,
    `json3=[${JSON.stringify(Object.assign(data, obj_data))}]`,
    config,
  );
};
//java star请求
export const $starGet = (url, params = {}, config = {}) => {
  return starInstance.get(url, { params, ...config });
};
//激励数据请求接口
export const $movaGet = (url, params = {}, config = {}) => {
  return mstance.get(url, { params, ...config });
};
//星启计划时长激励
export const $planGet = (url, params = {}, config = {}) => {
  return starPlanInstance.get(url, { params, ...config });
};
export const $planPost = (url, data = {}, config) => {
  return starPlanInstance.post(url, data, config);
};

export const $actPost = (url, data = {}, config) => {
  return actInstance.post(url, { ...data }, config);
};
export const $actGet = (url, params = {}, config = {}) => {
  return actInstance.get(url, { params, ...config, json: 1 });
};
